import { formatPercent } from '@/lib/format';
import { IconArrowDown, IconArrowUp, IconMinus } from './Icons';

interface GrowthTagProps {
  growth: number | null;
  /** O valor do período anterior, já formatado — aparece ao passar o mouse. */
  previousLabel: string;
  compact?: boolean;
}

/**
 * Variação contra o período anterior: seta e percentual, e a cor diz se subiu
 * ou caiu. Sem base de comparação, diz isso em vez de inventar um número.
 */
export function GrowthTag({ growth, previousLabel, compact }: GrowthTagProps) {
  if (growth === null) {
    return (
      <span className="chip" title="Sem base de comparação no período anterior">
        <IconMinus /> {compact ? 'novo' : 'sem base anterior'}
      </span>
    );
  }
  const up = growth >= 0;
  return (
    <span className={`chip ${up ? 'chip-positive' : 'chip-negative'}`} title={`Período anterior: ${previousLabel}`}>
      {up ? <IconArrowUp /> : <IconArrowDown />}
      <span className="sr-only">{up ? 'Alta de' : 'Queda de'}</span>
      {formatPercent(Math.abs(growth))}
    </span>
  );
}
